'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAttachMoney = function MdAttachMoney(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.7 18.2c3.7 1 7.8 2.5 7.8 7.3 0 3.4-2.6 5.3-5.9 5.9v3.6h-5v-3.6c-3.2-0.7-5.8-2.7-6-6.4h3.6c0.2 2 1.5 3.5 4.9 3.5 3.7 0 4.6-1.8 4.6-3 0-1.5-0.9-3-5-4-4.7-1.1-7.8-3.1-7.8-6.9 0-3.2 2.5-5.3 5.7-6v-3.6h5v3.7c3.6 0.8 5.4 3.4 5.4 6.3h-3.6c-0.1-2.1-1.3-3.5-4.3-3.5-2.8 0-4.4 1.3-4.4 3.1 0 1.6 1.2 2.6 5 3.6z' })
        )
    );
};

exports.default = MdAttachMoney;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/attach-money.js
// module id = 2079
// module chunks = 0